import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';

import styles from './ClosedCaptionsButton.module.scss';

const messages = {
  closedCaptioning: {
    id: 'tile.settings.closedCaptioning.header',
    description: 'closed captioning',
  },
  closedCaptioningOn: {
    id: 'tile.settings.closedCaptioning.on',
    description: 'closed captioning state on',
  },
  closedCaptioningOff: {
    id: 'tile.settings.closedCaptioning.off',
    description: 'closed captioning state off',
  },
};

interface ClosedCaptionsButtonProps {
  focusId?: string | null;
  onClick?: () => void;
  ttsText?: string | null;
  isOnButton?: boolean;
  isSelected?: boolean;
}

const ClosedCaptionsButton = ({
  focusId = null,
  onClick = () => {},
  ttsText = '',
  isOnButton = false,
  isSelected = false,
}: ClosedCaptionsButtonProps) => {
  const intl = useIntl();

  return (
    <Selectable
      focusId={focusId}
      className={styles.ccButton}
      ttsText={ttsText}
      onSelect={onClick}
      render={({ hasFocus }: { hasFocus: boolean }) => (
        <button
          type="button"
          onClick={onClick}
          className={classNames({
            [styles.focused]: hasFocus,
            [styles.selected]: isSelected,
          })}
          data-testid={`closed-captions-button-${isOnButton ? 'on' : 'off'}`}
        >
          <div className="d-flex align-items-center justify-content-center">
            <div
              data-testid="closed-captioning-icon"
              className={classNames(styles.ccIcon, isOnButton && styles.ccOn)}
            >
              {intl.formatMessage(messages.closedCaptioning)}
            </div>
            <div
              data-testid="closed-captioning-status"
              className="text-uppercase"
            >
              {intl.formatMessage(
                messages[
                  isOnButton ? 'closedCaptioningOn' : 'closedCaptioningOff'
                ],
              )}
            </div>
          </div>
        </button>
      )}
    />
  );
};

export default React.memo(ClosedCaptionsButton);
